import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import InsertLink from "@material-ui/icons/InsertLink";
import LinkOff from "@material-ui/icons/LinkOff";

// Switch on Kit equivalent of the repeated ITE right/left section header.
const SwitchOnKitSectionHeader = ({ title, rightSelected, leftSelected, linked, setLinked, children }) => (
  <Row className="order-builder-component-title">
    <Col xs={4}><h2>{title}</h2></Col>
    <Col xs={8}><Row>
      <Col xs={5}>{rightSelected && <p className="right-ear-title ear-impression-option mb-0"><span className="dot dot-right"></span>Right Ear</p>}</Col>
      <Col xs={2}>{rightSelected && leftSelected && <div className="text-center link-div">
        {linked ? <InsertLink className="linked" onClick={() => setLinked(false)} /> : <LinkOff className="unlinked" onClick={() => setLinked(true)} />}
      </div>}</Col>
      <Col xs={5}>{leftSelected && <p className="left-ear-title ear-impression-option mb-0"><span className="dot dot-left"></span>Left Ear</p>}</Col>
      {children}
    </Row></Col>
  </Row>
);

SwitchOnKitSectionHeader.propTypes = {
  title: PropTypes.string.isRequired, rightSelected: PropTypes.bool,
  leftSelected: PropTypes.bool, linked: PropTypes.bool,
  setLinked: PropTypes.func, children: PropTypes.node,
};

export default SwitchOnKitSectionHeader;
